import { FormbrewError, isFormbrewError } from "./errors.ts";
import { isAbortError } from "./predicates.ts";
import type { RendererLifecycle } from "./renderer.types.ts";

export { isAbortError };

export const createRendererLifecycle = (externalSignal?: AbortSignal): RendererLifecycle => {
  const controller = new AbortController();
  const abortFromExternal = () => {
    controller.abort(externalSignal?.reason);
  };

  if (externalSignal?.aborted) {
    abortFromExternal();
  } else {
    externalSignal?.addEventListener("abort", abortFromExternal, { once: true });
  }

  return {
    abort: () => {
      controller.abort();
    },
    cleanup: () => {
      externalSignal?.removeEventListener("abort", abortFromExternal);
    },
    signal: controller.signal,
  };
};

export const normalizeRendererError = (error: unknown, fallbackMessage: string): FormbrewError => {
  if (isFormbrewError(error)) {
    return error;
  }

  let message = fallbackMessage;
  if (error instanceof Error) {
    message = error.message;
  }

  return new FormbrewError(message, {
    cause: error,
    code: "RendererError",
  });
};
